"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportRawError = void 0;
var logger_1 = require("./logger");
function reportRawError(error, sender) {
    var messageContext = {
        date: error.startClocks.timeStamp,
        error: {
            kind: error.type,
            origin: error.source,
            stack: error.stack,
        },
        origin: error.source,
    };
    sender.sendToHttp(error.message, messageContext, logger_1.StatusType.error);
}
exports.reportRawError = reportRawError;
//# sourceMappingURL=reportRawError.js.map